function mountVueInstance (Vue, App, options = {}) {
  new Vue({
    ...options,
    render: h => h(App)
  }).$mount('#app')
}

export default mountVueInstance
